import { X } from "lucide-react";
import ItineraryCreationForm from "@/components/ItineraryCreationForm";

interface ModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ItineraryCreationModal({ open, onClose }: ModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-xl w-full p-8 relative overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
          aria-label="Close Modal"
        >
          <X size={24} />
        </button>

        <h2 className="text-3xl font-bold mb-4 text-gray-800 text-center">
          Create Your Custom Trip
        </h2>
        <p className="text-center text-gray-700 mb-6">
          Let&apos;s plan that personalized trip itinerary just for you!
        </p>

        <div className="bg-gradient-to-r from-blue-700 to-blue-500 p-6 rounded-xl">
          <ItineraryCreationForm />
          <p className="mt-4 text-white text-sm text-center">
            Enter the name of any place or destination
          </p>
        </div>
      </div>
    </div>
  );
}
